import { render, staticRenderFns } from "./right.vue?vue&type=template&id=649c1be8&scoped=true&"
import script from "./right.vue?vue&type=script&lang=js&"
export * from "./right.vue?vue&type=script&lang=js&"
import style0 from "./right.vue?vue&type=style&index=0&id=649c1be8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649c1be8",
  null
  
)

export default component.exports